/**
 * Зависимости
 */
import MapFilter from '../../components/yandex-map/infrastructure-checkbox-filter';
import {Utils} from '../../common/scripts/utils';
import YandexMap from '../../components/yandex-map';

/**
  * Карта в блоке Расположение
  */
const filterListBtn = document.querySelector('.j-infrastructure-filter-list-toggle');
const filterList = document.querySelector('.j-infrastructure-list');
const locationMap = document.querySelector('.j-infrastructure-map');
const filterCheckboxToggler = document.querySelector('.j-checkbox-toggle');
const mapFilterWrapper = document.querySelector('.j-map-filter');
const closeTriggers = [...document.querySelectorAll('.j-map-filter-close, .j-map-filter-overlay')];

let isLoaded = false;

const closeFilter = () => {
    filterList.classList.toggle('is-open');
    filterListBtn.classList.toggle('is-open');
};

const initLocationMap = () => {
    isLoaded = true;

    if (mapFilterWrapper) {
        const mapFilter = new MapFilter();

        mapFilter.init({target: mapFilterWrapper});

        if (filterCheckboxToggler) {
            filterCheckboxToggler.querySelector('span').innerHTML = 'Все';
            filterCheckboxToggler.addEventListener('click', () => {
                mapFilter.changeCheckBoxState();
                mapFilter.showAll(filterCheckboxToggler);
            });
        }
    }

    if (filterListBtn && filterList) {
        filterListBtn.addEventListener('click', () => {
            closeFilter();
        });
    }

    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            const yandexMap = new YandexMap(ymaps);

            yandexMap.init({
                wrapper                : locationMap,
                cluster                : true,
                fullScreenControl      : true,
                customFullScreenControl: true,
                customZoomControl      : true
            });
        });
    }
};

closeTriggers.forEach((item) => {
    item.addEventListener('click', () => {
        closeFilter();
    });
});

// TODO: Функция дублируется в sections/contacts-page/index.js, sections/developer-roadmap-map/index.js, sections/location/index.js - вынести в утилиты, прописать ключ для карты
const checkMap = () => {
    const ymaps = window.ymaps;

    if (ymaps) {
        initLocationMap();
    } else {
        Utils.loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', initLocationMap);
    }
};

if (locationMap) {
    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!isLoaded) {
                        checkMap();
                    }
                }
            });
        }, {rootMargin: '0px 0px 1000px 0px'});

        if (Utils.isInViewport(locationMap, window.innerHeight || document.documentElement.clientHeight)) {
            checkMap();
        } else {
            lazyImageObserver.observe(locationMap);
        }
    } else {
        checkMap();
    }
}

